import forge from 'node-forge';

const publicKeyPem = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA+DzJMZgSY91CMoA5EUZV
iYzNvtH65zFH0CJN2thkjRG7722z0XZl5VJMy4kpv1EqtsRNlxpQD1430KJOuqlQ
73J1TIKj0zKQGIqfMDT/JN8uBuLO4P6yk0mvDBNzj5wY6OsA+W3Ur1iM9dPDC4S9
fObexqIhwY8gNFOCmDz9ObjLChu+nRUITA2Ze4LnU2gSgIukgkHOemD51vJ/DNAE
nDYsBcALCCmIUDvcFXWWeA3kb053AVr62ZHx7ltOpb8xNgawzV0AjKYo9n4wkiip
kznaqBUGtTOav02fu035BaFUQqXQ9sYrEXnNlqDtjbBzZf16xiCNqss29/cLvWGo
4wIDAQAB
-----END PUBLIC KEY-----`;

export const encryptPassword = (password) => {
  try {
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    const encrypted = publicKey.encrypt(password, 'RSA-OAEP', {
      md: forge.md.sha256.create(),
    });

    const encryptedBase64 = forge.util.encode64(encrypted);
    return encryptedBase64;
  } catch (error) {
    console.error('Encryption failed:', error);
    return null;
  }
};
